<template>
  <div class="mv-bg-main" style="overflow: scroll;">
    <el-card class="mr">
      <el-row>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">今日新增客户</p>
            <p class="center_task" style="color: #7FFFAA;">{{addCust}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">今日充值客户</p>
            <p class="center_task" style="color: #FFA500;">{{rechargeCust}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">今日活跃客户</p>
            <p class="center_task" style="color: #FFD700;">{{activeCust}}</p>
          </div>
        </el-col>
      </el-row>
      <el-row class="">
        <el-col :span="8">
          <div class="task">
            <p class="center_task">存量客户</p>
            <p class="center_task" style="color: #FF69B4;">{{stockCust}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">存量活跃客户</p>
            <p class="center_task" style="color: #0000CD;">{{stockActiveCust}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">存量待激活客户</p>
            <p class="center_task" style="color: #00BFFF;">{{stockUnActiveCust}}</p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mr">
      <el-row>
        <el-col :span="12">
          <el-card style="height: 800px;">
            <div slot="header" class="clearfix">
              <span class="card-title">客户调用排行</span>
            </div>
            <el-row>
              <el-col :span="12">
                <span class="cursor" v-bind:class="{ color: callDayColor }" @click="callDay"> 日</span>
                <span class="cursor" v-bind:class="{ color: callMonthColor }" @click="callMonth">月</span>
                <span class="cursor" v-bind:class="{ color: callYearColor }" @click="callYear">年</span>
              </el-col>
              <el-col :span="12">
                <!-- <el-button type="primary" style="float: right;" size="small">完整排行</el-button> -->
              </el-col>
            </el-row>
            <el-table
              :data="tableCusData"
              style="width: 100%;margin-top: 10px;">
              <el-table-column
                label="排名"
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                label="客户"
                :show-overflow-tooltip="tooltip"
                width="">
                <template slot-scope="scope">
                  <span >{{ scope.row.custName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="调用量(笔)"
                :show-overflow-tooltip="tooltip"
                width="">
                <template slot-scope="scope">
                  <span >{{ scope.row.callNum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="活跃度"
                :show-overflow-tooltip="tooltip"
                width="">
                <template slot-scope="scope">
                  <el-progress :stroke-width="14" :text-inside="true" :percentage="parseInt(scope.row.activeNum * 100)"></el-progress>
                </template>
              </el-table-column>
              <el-table-column
                label=""
                width="">
                <template slot-scope="scope">
                  <span :class="scope.row.addRate > 0 ? 'rise': 'down'" ></span>
                  <span class="rate">{{ parseInt(scope.row.addRate * 100) + '%' }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt center"
              background
              @size-change="handleCustCallSizeChange"
              :current-page="custCallPageNum"
              @current-change="handleCustCallCurrentChange"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="custCallPageSize"
              layout="total, sizes, prev, pager, next"
              :total="custCallTotal">
            </el-pagination>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card style="height: 800px;">
            <div slot="header" class="clearfix">
              <span class="card-title">客户消费排行</span>
            </div>
            <el-row>
              <el-col :span="12">
                <span class="cursor" v-bind:class="{ color: consumeDayColor }" @click="consumeDay"> 日</span>
                <span class="cursor" v-bind:class="{ color: consumeMonthColor }" @click="consumeMonth">月</span>
                <span class="cursor" v-bind:class="{ color: consumeYearColor }" @click="consumeYear">年</span>
              </el-col>
              <el-col :span="12">
                <!-- <el-button type="primary" style="float: right;" size="small">完整排行</el-button> -->
              </el-col>
            </el-row>
            <el-table
              :data="tableCusConsumeData"
              style="width: 100%; margin-top: 10px;">
              <el-table-column
                label="排名"
                type="index"
                width="50">
              </el-table-column>
              <el-table-column
                label="客户"
                :show-overflow-tooltip="tooltip"
                width="">
                <template slot-scope="scope">
                  <span >{{ scope.row.custName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="消费金额(元)"
                :show-overflow-tooltip="tooltip"
                width="">
                <template slot-scope="scope">
                  <span >{{ scope.row.consumeAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="活跃度"
                :show-overflow-tooltip="tooltip"
                width="">
                <template slot-scope="scope">
                  <!-- <el-progress :stroke-width="14" :text-inside="true" :percentage="parseInt(scope.row.activeNum * 100)"></el-progress> -->
                  <span :class="scope.row.addRate > 0 ? 'rise': 'down'" ></span>
                  <span class="rate">{{ parseInt(scope.row.addRate * 100) + '%' }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt center"
              background
              @size-change="handleConsumeSizeChange"
              :current-page="custConsumePageNum"
              @current-change="handleConsumeCurrentChange"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="custConsumePageSize"
              layout="total, sizes, prev, pager, next"
              :total="custConsumeTotal">
            </el-pagination>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mr">
      <div slot="header" class="clearfix">
        <span class="card-title">客户充值排行</span>
      </div>
      <el-row>
        <el-col :span="12">
          <span class="cursor" v-bind:class="{ color: rechargeDayColor }" @click="rechargeDay"> 日</span>
          <span class="cursor" v-bind:class="{ color: rechargeMonthColor }" @click="rechargeMonth">月</span>
          <span class="cursor" v-bind:class="{ color: rechargeYearColor }" @click="rechargeYear">年</span>
        </el-col>
        <el-col :span="12">
          <!-- <el-button type="primary" style="float: right;" size="small">完整排行</el-button> -->
        </el-col>
      </el-row>
      <el-table
        :data="tableCusRechargeData"
        style="width: 100%;margin-top: 10px;">
        <el-table-column
          label="排名"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          label="客户"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.custName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="充值金额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.chargeAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户余额(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.accoutBalance }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="消费热度"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <el-progress :stroke-width="14" :text-inside="true" :percentage="parseInt(scope.row.consumeHeat * 100)"></el-progress>
          </template>
        </el-table-column>
        <el-table-column
          label=""
          width="">
          <template slot-scope="scope">
            <span :class="scope.row.addRate > 0 ? 'rise': 'down'" ></span>
            <span class="rate">{{ parseInt(scope.row.addRate * 100)  + '%'}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleRechargeSizeChange"
        :current-page="custRechargePageNum"
        @current-change="handleRechargeCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="custRechargePageSize"
        layout="total, sizes, prev, pager, next"
        :total="custRechargeTotal">
      </el-pagination>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.cursor {
  cursor: pointer;
}
.rise {
  background: url(../../assets/shangsheng.png) no-repeat center;
  background-size: 100%;
  width: 18px;
  float: left;
  height: 25px;
  margin-top: 5px;
}
.rate {
  margin-top: 8px;
  margin-left: 15px;
  float: left;
}
.down {
  background: url(../../assets/xiajiang.png) no-repeat center;
  background-size: 100%;
  width: 18px;
  float: left;
  height: 25px;
  margin-top: 5px;
}
.color {
  color: #00c2de;
  cursor: pointer;
}
.color:hover {
  cursor: pointer;
  text-decoration: underline;
}
.mr {
  margin: 10px;
}
.task {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 80px;
}
.center_task {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
.float {
  float: left;
}
</style>
<script>
export default {
  name: 'customerAnalysis',
  data () {
    return {
      tableCusData: [],
      tableCusConsumeData: [],
      tableCusRechargeData: [],
      consumeDayColor: true,
      consumeMonthColor: false,
      consumeYearColor: false,
      callDayColor: true,
      callMonthColor: false,
      callYearColor: false,
      rechargeDayColor: true,
      rechargeMonthColor: false,
      rechargeYearColor: false,
      dateCallType: 1,
      dateConsumeType: 1,
      dateRechargeType: 1,
      custCallPageNum: 1,
      custCallPageSize: 10,
      custCallTotal: 0,
      custConsumePageNum: 1,
      custConsumePageSize: 10,
      custConsumeTotal: 0,
      custRechargePageNum: 1,
      custRechargePageSize: 10,
      custRechargeTotal: 0,
      addCust: '',
      rechargeCust: '',
      activeCust: '',
      stockCust: '',
      stockActiveCust: '',
      stockUnActiveCust: '',
      tooltip: true
    }
  },
  created () {
    this.query()
    this.queryCustCall()
    this.queryCusConsume()
    this.queryCustRecharge()
  },
  methods: {
    callDay () {
      this.dateCallType = 1
      this.callMonthColor = false
      this.callYearColor = false
      this.callDayColor = true
      this.queryCustCall()
    },
    callMonth () {
      this.dateCallType = 2
      this.callMonthColor = true
      this.callYearColor = false
      this.callDayColor = false
      this.queryCustCall()
    },
    callYear () {
      this.dateCallType = 3
      this.callYearColor = true
      this.callMonthColor = false
      this.callDayColor = false
      this.queryCustCall()
    },
    consumeDay () {
      this.dateConsumeType = 1
      this.consumeMonthColor = false
      this.consumeDayColor = true
      this.consumeYearColor = false
      this.queryCusConsume()
    },
    consumeMonth () {
      this.dateConsumeType = 2
      this.consumeMonthColor = true
      this.consumeDayColor = false
      this.consumeYearColor = false
      this.queryCusConsume()
    },
    consumeYear () {
      this.dateConsumeType = 3
      this.consumeYearColor = true
      this.consumeMonthColor = false
      this.consumeDayColor = false
      this.queryCusConsume()
    },
    rechargeDay () {
      this.dateRechargeType = 1
      this.rechargeMonthColor = false
      this.rechargeDayColor = true
      this.rechargeYearColor = false
      this.queryCustRecharge()
    },
    rechargeMonth () {
      this.dateRechargeType = 2
      this.rechargeMonthColor = true
      this.rechargeDayColor = false
      this.rechargeYearColor = false
      this.queryCustRecharge()
    },
    rechargeYear () {
      this.dateRechargeType = 3
      this.rechargeYearColor = true
      this.rechargeMonthColor = false
      this.rechargeDayColor = false
      this.queryCustRecharge()
    },
    handleCustCallSizeChange (val) {
      this.custCallPageSize = val
      this.custCallPageNum = 1
      this.queryCustCall()
    },
    handleCustCallCurrentChange (val) {
      this.custCallPageNum = val
      this.queryCustCall()
    },
    handleConsumeSizeChange (val) {
      this.custConsumePageSize = val
      this.custConsumePageNum = 1
      this.queryCusConsume()
    },
    handleConsumeCurrentChange (val) {
      this.custConsumePageNum = val
      this.queryCusConsume()
    },
    handleRechargeSizeChange (val) {
      this.custRechargePageSize = val
      this.custRechargePageNum = 1
      this.queryCustRecharge()
    },
    handleRechargeCurrentChange (val) {
      this.custRechargePageNum = val
      this.queryCustRecharge()
    },
    query () {
      /* 查询客户统计分析 */
      let _this = this
      this.$axios({
        url: this.$API.analysis.queryCustAnalysisData,
        method: 'post',
        data: {}
      }).then((response) => {
        let data = response.data.resData
        _this.addCust = data.newCustNum
        _this.rechargeCust = data.chargeCustNum
        _this.activeCust = data.activeCustNum
        _this.stockCust = data.stockCustNum
        _this.stockActiveCust = data.stockActiveCustNum
        _this.stockUnActiveCust = data.stockToActiveCustNum
      }).catch((err) => {
        console.log(err)
      })
    },
    /* 查询客户充值排行 */
    queryCustRecharge () {
      let op = {}
      let _this = this
      op.dateType = this.dateRechargeType
      op.date = ''
      op.pageNum = this.custRechargePageNum
      op.pageSize = this.custRechargePageSize
      this.$axios({
        url: this.$API.analysis.queryCustChargeDataByPage,
        method: 'post',
        data: op
      }).then((response) => {
        let data = response.data.resData.resultList
        _this.tableCusRechargeData = data
        this.custRechargeTotal = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    },
    /* 查询客户消费排行 */
    queryCusConsume () {
      let op = {}
      let _this = this
      op.dateType = this.dateConsumeType
      op.date = ''
      op.pageNum = this.custConsumePageNum
      op.pageSize = this.custConsumePageSize
      this.$axios({
        url: this.$API.analysis.queryCustConsumeDataByPage,
        method: 'post',
        data: op
      }).then((response) => {
        let data = response.data.resData.resultList
        _this.tableCusConsumeData = data
        this.custConsumeTotal = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    },
    /* 查询客户调用量 */
    queryCustCall () {
      let op = {}
      let _this = this
      op.dateType = this.dateCallType
      op.date = ''
      op.pageNum = this.custCallPageNum
      op.pageSize = this.custCallPageSize
      this.$axios({
        url: this.$API.analysis.queryCustCallNumByPage,
        method: 'post',
        data: op
      }).then((response) => {
        let data = response.data.resData.resultList
        _this.tableCusData = data
        this.custCallTotal = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/customerAnalysis.vue